/* src/app/features/honra/stoploss/stoploss-listagem/stoploss-listagem.component.css */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.legenda {
  font-size: 0.75rem;
  width: auto;
}
/*# sourceMappingURL=stoploss-listagem.component.css.map */
